import React from 'react';
import { Route } from 'react-router-dom';
import { Reports } from './components/reports';
import { PaymentFilesForm } from './components/paymentFiles';

export default [
  <Route key="reports" exact path="/reports" element={<Reports />} />,
  <Route key="payment-files" exact path="/payment-files" element={<PaymentFilesForm />} />,
];
